
import { defineComponent, reactive, onMounted } from 'vue';
import type { UnwrapRef } from 'vue';
interface FormState {
  remarksinfo: string;
}
export default defineComponent({
    name: "remarks",
    emits: ['update:visible','childRemarks'],
    props: {
        defaultRemarks: {
            type: Object,
            default: ()=>{return {}}
        },
    },
    setup(props, {emit}) {
        const formState: UnwrapRef<FormState> = reactive({
            remarksinfo: ''
        });
        const layout = {
            labelCol: { span: 8 },
            wrapperCol: { span: 16 },
        };
        const defaultRemarks = props.defaultRemarks;
        const childRemarks = {}
        const handleSubmit = async(e: MouseEvent) => {
            e.preventDefault()
            // defaultRemarks.remarks = formState.remarksinfo
            childRemarks['gwtNo'] = defaultRemarks.gwtNo;
            childRemarks['remarks'] = formState.remarksinfo;
            emit('childRemarks',childRemarks)
            console.log(childRemarks)
        }

        const handleCtrl =  async(e: MouseEvent) => {
            e.preventDefault()
            emit('update:visible',false)
        }


        onMounted(()=>{
            formState.remarksinfo = props.defaultRemarks.remarks
        })

        return {
            layout,
            handleSubmit,
            formState,
            handleCtrl
        }
    }
})
